// AI models available for test prompts, grouped by provider.
// The backend dispatches by model name ("gemini"/"claude" substring, otherwise OpenAI).
export const MODEL_OPTIONS: Record<string, string[]> = {
  openai: ['gpt-5.5', 'gpt-5.4-mini', 'gpt-5.4-nano', 'o3', 'o3-pro', 'o4-mini', 'o4-mini-high'],
  gemini: ['gemini-3.1-pro-preview', 'gemini-3.1-flash-lite-preview', 'gemini-2.5-pro', 'gemini-2.5-flash', 'gemini-2.5-flash-lite'],
  claude: ['claude-opus-4-7', 'claude-opus-4-5', 'claude-sonnet-4-6', 'claude-sonnet-4-5', 'claude-haiku-4-5-20251001'],
};
